import React from 'react';
import { useTranslationHook } from 'PyzShopUi/scripts/utils/translationHook';

const productLocalStoreAvailabilityInfo = props => {
    const { isAvailable, phoneNumber, isAvailableForClickAndCollect } = props;
    const { translate } = useTranslationHook();

    return (
        <>
            { isAvailable ? (
                <>
                    <div className="grid-x align-middle availability available">
                        <div className="cell auto bold">
                            {translate('Available, please reserve by telephone', { ns: 'article-detail' })}
                        </div>
                    </div>
                    {translate('Reserve your product by telephone at your local Louis store. We will hold your product for up to 2 business days free of charge.', { ns: 'article-detail' })}
                    <a id="availability-phone-button" className="button button-bordered" href={`tel:${ phoneNumber }`}>
                        <i className="icon icon-phone"></i><span>{ phoneNumber }</span>
                    </a>
                </>
            ) : (
                <>
                    <div className="grid-x align-middle availability not-available">
                        <div className="cell auto bold">
                            <a>
                                { translate('Unfortunately out of stock', { ns: 'article-detail' }) }
                            </a>
                        </div>
                    </div>
                    { isAvailableForClickAndCollect ? (
                            <div dangerouslySetInnerHTML={{ __html: translate('Order this product online now and pick it up at a Louis store. Please choose “Free delivery to a Louis store (Click & Collect)” as delivery address.', { ns: 'article-detail' }) }}></div>
                    ) : (
                                <div dangerouslySetInnerHTML={{ __html: translate('Order this product online now and have it delivered to your home.', { ns: 'article-detail' }) }}></div>
                    ) }
                </>
            ) }
        </>
    );
};

export default productLocalStoreAvailabilityInfo;
